import { lazy } from 'react'

import ConnectionsLoader from './loader'

export default {
  Connections: {
    Component: lazy(() => import('./Connections.Page')),
    Loader: ConnectionsLoader,
  },
}
